import { Card, Colors } from '@amelio/ui-library';

import { Bone } from '@/components/Skeleton/Skeleton';

// Skeleton Components for Questionnaire Creation
const QuestionnaireHeaderSkeleton = () => (
    <div className={'flex flex-col gap-6'}>
        <div className={'flex items-center justify-between'}>
            <Card
                borderColor={Colors.WHITE}
                borderRadius={'2xl'}
                className={'flex max-w-[640px] flex-row items-center gap-8 px-12 py-8'}
            >
                <div className={'flex flex-col gap-2'}>
                    <Bone className={'h-7 w-56'} />

                    <Bone className={'h-4 w-48'} />
                </div>
            </Card>
        </div>

        {/* Pills with Numbers */}
        <div className={'flex justify-between gap-3'}>
            <div className={'flex -space-x-2'}>
                {Array.from({ length: 6 }).map((_, index) => (
                    <Bone
                        key={index}
                        className={'h-10 w-10 rounded-full border-2 border-white'}
                    />
                ))}
            </div>

            <div>
                <Bone className={'h-10 w-24 rounded-lg'} />
            </div>
        </div>
    </div>
);

const TitleSkeleton = () => (
    <Card
        borderColor={Colors.WHITE}
        borderRadius={'2xl'}
        className={'flex gap-2 px-6 py-4'}
    >
        <Bone className={'h-6 w-32'} />
    </Card>
);

const ToolbarSkeleton = () => (
    <div className={'flex items-center justify-between pb-4'}>
        <div className={'flex items-center gap-3'}>
            <Bone className={'h-10 w-24 rounded-lg'} />
        </div>

        <div className={'flex items-center gap-2'}>
            <Bone className={'h-10 w-24 rounded-lg'} />

            <Bone className={'h-10 w-32 rounded-lg border-2 border-dashed border-gray-300'} />
        </div>
    </div>
);

const QuestionListSkeleton = () => (
    <div className={'flex flex-col gap-3 pt-6'}>
        {Array.from({ length: 5 }).map((_, index) => (
            <div
                key={index}
                className={'flex items-center justify-between rounded-lg bg-white p-4'}
            >
                <div className={'flex items-center gap-3'}>
                    <Bone className={'h-4 w-4'} />

                    <Bone className={'h-5 w-16'} />
                </div>

                <div className={'flex items-center gap-2'}>
                    <Bone className={'h-7 w-16 rounded-full'} />

                    <Bone className={'h-8 w-8 rounded-lg'} />
                </div>
            </div>
        ))}
    </div>
);

export const QuestionnaireCreationSkeleton = () => {
    return (
        <div className={'flex flex-col gap-6'}>
            <QuestionnaireHeaderSkeleton />

            <TitleSkeleton />

            <Card
                className={'flex w-full flex-col'}
                borderRadius={'2xl'}
            >
                <ToolbarSkeleton />

                <QuestionListSkeleton />
            </Card>
        </div>
    );
};
